export default __webpack_public_path__ + "static/media/oscer-pres-peripheral-oedema.39461086.svg";